module.exports = __webpack_public_path__ + "static/img/NZ.e2567a7b.jpg";